import { useNewPassword } from 'modules/user/hooks/newPassword'
import { FunctionComponent } from 'react'
import { MdCheck, MdClose } from 'react-icons/md'
import { ItemValidationPassword, Subtitle } from './styles'

const ValidatePassword: FunctionComponent = () => {
  const {
    isValidQuantidadeCaracteres,
    isValidCaracterEspecial,
    isValidCaracter,
    isValidCaracterNumerico,
    confirmPassword,
    newUserPassword,
  } = useNewPassword()
  const isMatch =
    newUserPassword && confirmPassword && newUserPassword === confirmPassword
  return (
    <>
      <Subtitle>Sua senha deve conter:</Subtitle>
      <ItemValidationPassword is_valid={isValidQuantidadeCaracteres}>
        {isValidQuantidadeCaracteres ? <MdCheck /> : <MdClose />}
        Pelo menos 8 caracteres
      </ItemValidationPassword>
      <ItemValidationPassword is_valid={isValidCaracterEspecial}>
        {isValidCaracterEspecial ? <MdCheck /> : <MdClose />}
        Um caracter especial
      </ItemValidationPassword>
      <ItemValidationPassword is_valid={isValidCaracter}>
        {isValidCaracter ? <MdCheck /> : <MdClose />}
        Uma letra
      </ItemValidationPassword>
      <ItemValidationPassword is_valid={isValidCaracterNumerico}>
        {isValidCaracterNumerico ? <MdCheck /> : <MdClose />}
        Um número
      </ItemValidationPassword>
      <ItemValidationPassword is_valid={isMatch}>
        {isMatch ? <MdCheck /> : <MdClose />}
        Confirmar senha
      </ItemValidationPassword>
    </>
  )
}

export default ValidatePassword
